<template>
  <video autoplay loop muted preload class="video-bg">
    <source :src="source" type="video/mp4">
  </video>
</template>

<script>
export default {
  name: 'VideoBg',
  props: {
    source: String
  }
}
</script>

<style lang="scss" scoped>
video.video-bg {
  position: fixed;
  z-index: -11;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  height: auto;
  width: auto;
  source {
    min-width: 100%;
    min-height: 100%;
    height: auto;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VideoBg.vue